import MESSAGES from '../constants/messages';

export const canSeeMixin = {
  methods: {
    canSeeMixin(roles) {
      try {
        return roles.includes(this.getAccType);
      } catch (err) {
        this.$toasted.error(MESSAGES.canSeeError, {
          theme: 'bubble',
          icon: 'fa-exclamation-circle',
          position: 'bottom-right',
          duration: 10000,
        });
      }
    },
  },
};
